var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageRightTail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 13",
    height: 13,
    width: 8,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M5.188,1H0v11.193l6.467-8.625 C7.526,2.156,6.958,1,5.188,1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.188,0H0v11.193l6.467-8.625C7.526,1.156,6.958,0,5.188,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageRightTail);
export default __webpack_public_path__ + "static/media/message-right-tail.9157f66457d8cfbfcaab99890a66dd09.svg";
export { ForwardRef as ReactComponent };